module.exports = __webpack_public_path__ + "static/media/BTC(Bitcoin).de7035d0.jpeg";